export default __webpack_public_path__ + "static/media/BLOG_CARD_1.2eb08e84.png";